import { all, takeLatest, call, put } from 'redux-saga/effects';
import actions from './actions';
import { postChange, fetchKarieUserSchedules, getChanges, fetchPharmacySchedules, fetchScheduleDetails, deleteScheduleById as deleteSchedule } from '../../../api/schedules/schedules';
import notifications from '../notification/actions';
import { SERVER_ERRORS } from '../../../api/SERVER_ERRORS';

export function* postScheduleChange(payload) {
    try {
        const response = yield call(postChange, payload.scheduleId);

        if (response.message && response.message === "OK") {
            yield put({
                type: actions.POST_SCHEDULE_CHANGE_SUCCESS,
            });
        } else {
            yield put(notifications.createNotification({
                code: SERVER_ERRORS.COULD_NOT_INSERT_SCHEDULE_CHANGE,
                mainAction: actions.POST_SCHEDULE_CHANGE_ERROR,
            }));
        }
    } catch (error) {
        yield put(notifications.createNotification({
            mainAction: actions.POST_SCHEDULE_CHANGE_ERROR
        }));
    }
}

export function* getScheduleChanges(payload) {
    try {
        const response = yield call(getChanges, payload.scheduleId);

        if (response.changes) {
            yield put({
                type: actions.FETCH_SCHEDULE_CHANGES_SUCCESS,
                changes: response.changes,
            });
        } else {
            yield put(notifications.createNotification({
                ...response[0],
                mainAction: actions.FETCH_SCHEDULE_CHANGES_ERROR,
            }));
        }
    } catch (error) {
        yield put(notifications.createNotification({
            mainAction: actions.FETCH_SCHEDULE_CHANGES_ERROR
        }));
    }
}

export function* getKarieUserSchedules(payload) {
    try {
        const response = yield call(fetchKarieUserSchedules, payload.patientId, payload.pharmacyId);
        if (response.schedules) {
            yield put({
                type: actions.FETCH_KARIE_USER_SCHEDULES_SUCCESS,
                schedules: response.schedules,
            });
        } else {
            yield put(notifications.createNotification({
                ...response[0],
                mainAction: actions.FETCH_KARIE_USER_SCHEDULES_ERROR,
            }));
        }
    } catch (error) {
        yield put(notifications.createNotification({
            mainAction: actions.FETCH_KARIE_USER_SCHEDULES_ERROR
        }));
    }
}

export function* getScheduleDetails(payload) {
    try{
        const response = yield call(fetchScheduleDetails, payload.scheduleId);
        if(response.schedule){
            yield put({
                type: actions.FETCH_SCHEDULE_DETAILS_SUCCESS,
                schedule: response.schedule
            });
        }else {
            yield put(notifications.createNotification({
                ...response[0],
                mainAction: actions.FETCH_SCHEDULE_CHANGES_ERROR
            }));
        }
    }catch(error) {
        yield put(notifications.createNotification({
            mainAction: actions.FETCH_SCHEDULE_DETAILS_ERROR
        }))
    }
}

export function* deleteById(payload) {
    try {
        const response = yield call(deleteSchedule, payload.scheduleId);

        if (response.message && response.message === "OK") {
            yield put(notifications.createNotification({
                mainAction: actions.DELETE_SCHEDULE_SUCCESS,
                message: "Schedule has been successfully deleted",
                status: "SUCCESS",
            }));
        } else {
            yield put(notifications.createNotification({ ...response[0], mainAction: actions.DELETE_SCHEDULE_ERROR }));
        }
    } catch (error) {
        yield put(notifications.createNotification({ mainAction: actions.DELETE_SCHEDULE_ERROR, code: SERVER_ERRORS.UNKNOWN_SERVER_ERROR }));
    }
}

export function* getPharmacySchedules(payload) {
    try {
        const response = yield call(fetchPharmacySchedules, payload);
        
        if (response.schedules) {
            yield put({
                type: actions.FETCH_PHARMACY_SCHEDULES_SUCCESS,
                schedules: response.schedules,
            });
        } else {
            yield put(notifications.createNotification({
                ...response[0],
                mainAction: actions.FETCH_PHARMACY_SCHEDULES_ERROR,
            }));
        }
    } catch (error) {
        yield put(notifications.createNotification({
            mainAction: actions.FETCH_PHARMACY_SCHEDULES_ERROR
        }));
    }
}

export default function* rootSaga() {
    yield all([
        yield takeLatest(actions.POST_SCHEDULE_CHANGE, postScheduleChange),
        yield takeLatest(actions.FETCH_KARIE_USER_SCHEDULES, getKarieUserSchedules),
        yield takeLatest(actions.FETCH_SCHEDULE_CHANGES, getScheduleChanges),
        yield takeLatest(actions.FETCH_PHARMACY_SCHEDULES, getPharmacySchedules),
        yield takeLatest(actions.FETCH_SCHEDULE_DETAILS, getScheduleDetails),
        yield takeLatest(actions.DELETE_SCHEDULE, deleteById)
    ]);
}
